import type { ReactNode } from 'react';
import type { IconName } from './Icon';
import { EmptyPanel } from './primitives';

// Fase 24B: estado vacio unificado (sustituye empty-panel / empty-state duplicados). Debe parecer
// intencional, no roto: titulo + descripcion + accion opcional + icono opcional (discreto, no ilustracion).
// P-075: dibuja el `EmptyPanel` del rediseño (una sola familia); `compact` va dentro de una tarjeta.
export function EmptyState({
  title,
  description,
  icon,
  action,
  compact = false,
}: {
  title: string;
  description?: ReactNode;
  icon?: IconName;
  action?: ReactNode;
  compact?: boolean;
}) {
  return <EmptyPanel action={action} className={compact ? 'n3-state--compact' : undefined} description={description} icon={icon} plain={compact} title={title} />;
}
